


















































import { Vue, Component, Prop } from "vue-property-decorator";
import { OrganizationStep } from "@/classes/enums/OrganizationStep";
import Organization from "@/classes/Organization";
import Domain from "@/classes/Domain";
import HIVETextField from "@/components/common/HIVETextField.vue";
import HIVEButton from "@/components/common/HIVEButton.vue";
import CreateDomainRequest from "@/classes/request_objects/accounts/domains/CreateDomainRequest";

@Component({
  components: {
    HIVETextField,
    HIVEButton,
  },
})
export default class CreateUpdateDomainForm extends Vue {
  @Prop(Boolean) public complete: boolean;
  @Prop(Boolean) public isNewOrganization: boolean;
  @Prop(Number) public step: number;
  @Prop(Object) public organization: Organization;

  private domain: CreateDomainRequest = new CreateDomainRequest();

  private get isComplete() {
    return this.complete;
  }

  private get getOrganization() {
    return this.organization;
  }

  private get getStepNumber() {
    return this.step;
  }

  private get getDomains() {
    return this.$store.getters["organizations/getDomains"];
  }
  private set getDomains(val: Array<Domain>) {
    this.$store.commit("organizations/setDomains", val);
  }

  private get addButtonDisabled() {
    return this.domain.name === "" ? true : false;
  }

  private checkSubmit(event: Event) {
    if (event && event.keyCode === 13) {
      this.createDomain();
    }
  }

  private createDomain() {
    if (this.domain.name !== "") {
      this.$store.dispatch("organizations/createDomain", this.domain);
      this.domain = new CreateDomainRequest();
    }
  }

  private removeDomain(domain: Domain) {
    this.$store.dispatch("organizations/removeDomain", domain);
  }

  private created() {
    if (this.getOrganization.id) {
      this.$store.dispatch("organizations/getDomains");
    } else {
      this.getDomains = [];
    }
  }
}
